import React from 'react'
import PropTypes from 'prop-types'

import { ResourceDetailsBlock } from '../../ProjectDescription.styles'

const Description = ({ yearOfOperation, upgradeYear, capacity, lang }) => {
  return (
    <>
      {yearOfOperation && (
        <ResourceDetailsBlock>
          <span className="label">
            {lang === 'en' ? `Year of Operation` : `سنة التشغيل`}
          </span>
          <span className="value">{yearOfOperation}</span>
        </ResourceDetailsBlock>
      )}
      {upgradeYear && upgradeYear.length > 0 && (
        <ResourceDetailsBlock>
          <span className="label">
            {lang === 'en' ? `Upgraded` : `سنة التوسعة`}
          </span>
          <span className="value">
            {upgradeYear.length === 1
              ? `${upgradeYear[0]}`
              : upgradeYear.map((year, i) =>
                  i === upgradeYear.length - 1 ? `${year}` : `${year} / `
                )}
          </span>
        </ResourceDetailsBlock>
      )}
      {capacity && (
        <ResourceDetailsBlock>
          <span className="label">
            {lang === 'en'
              ? 'Capacity (m³/day)'
              : 'القدرة التصميمية (م٣ في اليوم)'}
          </span>
          <span className="value">{capacity}</span>
        </ResourceDetailsBlock>
      )}
    </>
  )
}

Description.propTypes = {
  yearOfOperation: PropTypes.string,
  upgradeYear: PropTypes.array,
  capacity: PropTypes.string,
  lang: PropTypes.string
}

export default Description
